export const buildNumber = '20260702.4';
export const version = 'main';
export const latestCommit = 'b5c17d85622531b7034472c39d4d431667e01644';
